import useFullyFledgedField from '@gef-ui/form-core/hooks/field/useFullyFledgedField';
import chainHandlers from "@gef-ui/utils/chainHandlers";
import CheckboxComponent from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import PropTypes from 'prop-types';
import defaultTo from "ramda/es/defaultTo";
import React from 'react';
import { HIDDEN_HELPER_TEXT, validationDisplayTypes } from '../constants';
import { resolveValidationColor, useFieldDefaultValue } from '../utils';
export const COMPONENT_NAME = 'Checkbox';
const Checkbox = (inProps)=>{
    const props = useFieldDefaultValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { fieldName, fieldIndices, initiallyDirty, viewParser, modelParser, onChange, disabled: disabledByProp, defaultValue, label, validationDisplay, FormControlLabelProps = {}, ...other } = props;
    const { value, errorMessage, handleChange, validationType, localizedLabel, validateField, fieldId, disabled } = useFullyFledgedField({
        fieldName,
        fieldIndices,
        initiallyDirty,
        modelParser,
        viewParser,
        disabled: disabledByProp,
        defaultValue
    });
    const validationColor = resolveValidationColor(validationType, validationDisplay);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FormControlLabel, {
        control: /*#__PURE__*/ React.createElement(CheckboxComponent, {
            id: fieldId,
            checked: defaultTo(false, value),
            onChange: chainHandlers([
                handleChange,
                validateField,
                onChange
            ]),
            disabled: disabled,
            color: validationColor,
            ...other
        }),
        label: label ?? localizedLabel,
        ...FormControlLabelProps
    }), HIDDEN_HELPER_TEXT.includes(validationDisplay) ? null : /*#__PURE__*/ React.createElement(FormHelperText, {
        validation: validationColor
    }, errorMessage));
};
Checkbox.propTypes = {
    FormControlLabelProps: PropTypes.object,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    fieldIndices: PropTypes.arrayOf(PropTypes.number),
    fieldName: PropTypes.string,
    initiallyDirty: PropTypes.bool,
    label: PropTypes.node,
    modelParser: PropTypes.func,
    onChange: PropTypes.func,
    validationDisplay: PropTypes.oneOf(Object.keys(validationDisplayTypes)),
    viewParser: PropTypes.func
};
export default Checkbox;
